export const MAX_WEBP_DIMENSION = 16383;
export const MAX_AUTO_DIMENSION = 14500;
